import { FC, useEffect } from "react";
import { useAtomFamily } from "../../../../hooks/useAtomFamily";
import { BindInstructionsComponentsToSaveInfoProps } from "./PolicyQuoteBindInstructionsTypes";
import { INSURED_ATOM_KEY } from "../../../../utilities/queryStringsHash";
import { GlobalInsuredAtomFamily } from "../../InsuredAtoms";
import { getValidatedDateToPost } from "../../../../utilities/dateFunctions";
import { ProgramEndorsementFormWithCustomPolicyJSON } from "../../../../dtos/program-endorsement-form-with-custom-policy-json";
import { useApiGet } from "../../../../hooks";
import { isAPITotallyComplete } from "../../../../utilities/apiFunctions";
import { getAtomUpdatedByEndorsementForms } from "./PolicyQuoteBindInstructionsUtils";

const SaveEndorsementFormsInformation: FC<
  BindInstructionsComponentsToSaveInfoProps
> = ({ tabKey }) => {
  const insuredIdAtomKey = `${INSURED_ATOM_KEY} ${tabKey}`;
  const { getAtom, setAtom } = useAtomFamily(
    GlobalInsuredAtomFamily(insuredIdAtomKey)
  );

  const policyQuoteInformation = getAtom()?.policyQuoteInformation;
  const policyId = policyQuoteInformation?.policyId ?? 0;
  const quoteId = policyQuoteInformation?.quoteId ?? 0;
  const policyEffectiveDate = getValidatedDateToPost(
    policyQuoteInformation?.policyQuote?.effectiveDate
  );

  const {
    responseGet: responseGetEndorsements,
    dispatchGet: dispatchGetEndorsements,
  } = useApiGet<ProgramEndorsementFormWithCustomPolicyJSON>(
    `api/QuotePolicy/GetProgramEndorsement?policyId=${policyId}&quoteId=${quoteId}&effectiveDate=${policyEffectiveDate}`
  );

  useEffect(() => {
    if (isAPITotallyComplete(responseGetEndorsements)) {
      const atomValue = getAtom();
      const endorsementForms =
        responseGetEndorsements.axiosResponse?.data?.programEndorsementForms;
      const newAtomValueByEndorsementForms = getAtomUpdatedByEndorsementForms(
        atomValue,
        endorsementForms ?? []
      );

      setAtom(newAtomValueByEndorsementForms);
    }
  }, [responseGetEndorsements]);

  useEffect(() => {
    dispatchGetEndorsements();
  }, []);

  return null;
};
export default SaveEndorsementFormsInformation;
